
import React, { useState } from 'react';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { UsersSection } from '@/components/admin/UsersSection';
import { StatisticsSection } from '@/components/admin/StatisticsSection';
import { TopBreedersSection } from '@/components/admin/TopBreedersSection';
import { TopAuctionsSection } from '@/components/admin/TopAuctionsSection';
import { SidebarProvider } from '@/components/ui/sidebar';
import { BottomNavigation } from '@/components/BottomNavigation';

const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState('statistics');

  const renderSection = () => {
    switch (activeSection) {
      case 'statistics':
        return <StatisticsSection />;
      case 'users':
        return <UsersSection />;
      case 'top-breeders':
        return <TopBreedersSection />;
      case 'top-auctions':
        return <TopAuctionsSection />;
      default:
        return <StatisticsSection />;
    }
  };

  return (
    <ProtectedRoute requiredUserType="admin">
      <SidebarProvider>
        <div className="min-h-screen flex w-full bg-gray-50">
          <AdminSidebar 
            activeSection={activeSection} 
            onSectionChange={setActiveSection} 
          />
          <main className="flex-1 p-3 md:p-6 pb-20 md:pb-6">
            {renderSection()}
          </main>
        </div>
        
        <BottomNavigation
          userType="admin"
          activeSection={activeSection}
          onSectionChange={setActiveSection}
        />
      </SidebarProvider>
    </ProtectedRoute>
  );
};

export default AdminDashboard;
